import {
    LocationOn as LocationIcon
} from '@mui/icons-material';
import {
    Box,
    Chip,
    Grid,
    Paper,
    Typography,
    useTheme
} from '@mui/material';
import React from 'react';
import { StyledContainer, StyledLocationCard, StyledLocationMap, StyledSection, StyledSectionSubtitle, StyledSectionTitle } from './styled/CommonStyles.tsx';

export const LocationSection: React.FC = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <StyledSection
      id="location"
      component="section"
      aria-labelledby="location-heading"
    >
      <StyledContainer>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <StyledSectionTitle 
            variant="h4" 
            component="h2" 
            id="location-heading"
          >
            <LocationIcon />
            Locatie
          </StyledSectionTitle>
          <StyledSectionSubtitle variant="body1">
            Pippaya Hondenopvang is gevestigd in Giessenburg. Kennismaken kan op afspraak.
          </StyledSectionSubtitle>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {/* Google Maps */}
          <Grid item xs={12} md={8}>
            <Paper 
              elevation={4}
              sx={{ 
                height: '400px',
                overflow: 'hidden',
                borderRadius: 3,
                backgroundColor: isDarkMode ? 'background.paper' : 'white'
              }}
            >
              <StyledLocationMap>
                <StyledLocationCard>
                  <LocationIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, color: 'primary.main' }}>
                    Pippaya Hondenopvang
                  </Typography>
                  <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center', mb: 3 }}>
                    Boezem 7<br />
                    3381 DJ Giessenburg
                  </Typography>
                  <Chip 
                    label="📍 Open in Google Maps" 
                    color="primary" 
                    variant="filled"
                    onClick={() => window.open('https://maps.google.com/?q=Giessenburg+Boezem+7,+3381+DJ+Giessenburg,+Netherlands', '_blank')}
                    sx={{ 
                      cursor: 'pointer',
                      backgroundColor: 'primary.main',
                      color: 'white',
                      fontWeight: 'bold',
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  />
                </StyledLocationCard>
              </StyledLocationMap>
            </Paper>
          </Grid>
        </Grid>

      </StyledContainer>
    </StyledSection>
  );
}; 